import { render, staticRenderFns } from "./extrato-qualificacao-economica.vue?vue&type=template&id=4c08d9dc"
import script from "./extrato-qualificacao-economica.vue?vue&type=script&lang=js"
export * from "./extrato-qualificacao-economica.vue?vue&type=script&lang=js"
import style0 from "./extrato-qualificacao-economica.vue?vue&type=style&index=0&id=4c08d9dc&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports